<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <el-row :gutter="10" class="mgb-20">
      <el-col :span="4">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img1"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">5</span>单</p>
            <p>待入库</p>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img3"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">5</span>单</p>
            <p>今日新增入库单</p>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img4"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">55</span>单</p>
            <p>已入库单数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img5"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">125</span>单</p>
            <p>入库单总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img2"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">565</span>单</p>
            <p>待入库总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-image
            class="img"
            src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">5</span>单</p>
            <p>已入库总数</p>
          </div>
        </div>
      </el-col>
    </el-row>
     <!-- 查询条件 -->  
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="订单状态" prop="state">
        <el-select v-model="searchForm.state" placeholder="全部">
          <el-option label="待发货" value="0"></el-option>
          <el-option label="已入库" value="1"></el-option>
          <el-option label="待入库" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="输入搜索" prop="keyword">
        <el-input
          v-model="searchForm.keyword"
          placeholder="请输入入库单编号/物流单号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <btns @exec="exec"></btns>
    <div class="mgt-18">
      <el-button plain size="small" type="">导出</el-button>
    </div>
    <div class="data-container scroll-table">
      <!-- 库存列表 -->
      <el-table
        :data="tableData"
        border
        class="mgt-18"
        style="width: 100%"
        @selection-change="tableSelectionChange"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="customerName" label="序号入库单编号">
        </el-table-column>
        <el-table-column prop="customerName" label="发货回收站">
        </el-table-column>
        <el-table-column prop="customerName" label="数量"> </el-table-column>
        <el-table-column prop="customerName" label="物流公司">
        </el-table-column>
        <el-table-column prop="customerName" label="发货时间">
        </el-table-column>
        <el-table-column prop="customerName" label="入库时间">
        </el-table-column>
        <el-table-column prop="customerName" label="状态"> </el-table-column>
        <el-table-column prop="customerStatus" label="操作">
          <template slot-scope="scope">
            <button v-if="scope.row.customerStatus == 0" type="danger">
              查看物流
            </button>
            <button v-if="scope.row.customerStatus == 1">确认入库</button>
            <button v-if="scope.row.customerStatus == 2">查看入库单</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.totalCount"
      >
      </el-pagination>
    </div>
    <!-- 查看物流 -->
    <el-dialog
      title="物流信息"
      :visible.sync="logisticsDialogVisible"
      width="30%"
      center>
      <div class="block">
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logisticsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="logisticsDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 入库单 -->
    <el-dialog
      title="入库单"
      :visible.sync="warehouseWarrantDialogVisible"
      center
    >
      <div class="flex-between mgb-5 pdr-10 pdl-20">
        <span>入库单编号:No.203974878</span>
        <span>发货回收站:成都武侯区天府广场回收驿站</span>
      </div>
      <div class="flex-between row el-button--primary mgb-10">
        <span>发货人:张三</span>
        <span>联系电话:13684444444</span>
        <span>发货地址:四川省成都市武侯区233号</span>
      </div>
      <div class="flex hgt45 row">
        <span class="flex1">单位</span> <span class="flex1">数量</span>
      </div>
      <div class="flex hgt45 row">
        <span class="flex1">个</span> <span class="flex1">100</span>
      </div>
      <div class="flex hgt45 row"><span class="flex1">备注:备注说明</span></div>

      <p>实际入库信息</p>
      <div class="border-8e pd-20 mgb-20">
        <el-radio-group v-model="radio">
          <el-radio :label="3">有次品</el-radio>
          <el-radio :label="6">无次品</el-radio>
        </el-radio-group>
        <el-row class="mgb-10 mgt-20" :gutter="20">
          <el-col :span="6">
            <el-select v-model="value" placeholder="选择品牌">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="flex-center">
            <span class="mgr-10 w60">次品数</span
            ><el-input
              placeholder="请输入该品牌次品数量"
              v-model="input"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row class="mgb-10" :gutter="20">
          <el-col :span="6">
            <el-select v-model="value" placeholder="选择品牌">
              <!-- <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              > -->
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="flex-center">
            <span class="mgr-10 w60">入库数</span
            ><el-input
              placeholder="请输入该品牌入库数量"
              v-model="input"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="6">
            <el-button size="mini">添加数据</el-button>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="mgb-10" :gutter="20">
          <el-col :span="6">
            <el-select v-model="value" placeholder="选择品牌">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="flex-center">
            <span class="mgr-10 w60">入库数</span
            ><el-input
              placeholder="请输入该品牌入库数量"
              v-model="input"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row class="mgb-10" :gutter="20">
          <el-col :span="6">
            <el-select v-model="value" placeholder="选择品牌">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="flex-center">
            <span class="mgr-10 w60">次品数</span
            ><el-input
              placeholder="请输入该品牌次品数量"
              v-model="input"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="6">
            <el-button size="mini">添加数据</el-button>
          </el-col>
        </el-row>
      </div>
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="3">实收数:98</el-col>
        <el-col :span="3">偏差数:-2</div></el-col>
        <el-col :span="3">次品数:3</el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="warehouseWarrantDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="warehouseWarrantDialogVisible = false">确 定</el-button> -->
      </span>
      <!--  { type: 'number', message: '年龄必须为数字值'} -->
      <el-form :model="form" label-width="100px" class="demo-ruleForm mgt-20">
        <el-form-item
          label="物流成本"
          prop="price"
          :rules="[
            { required: true, message: '请输入物流成本'},
          ]"
        >
          <el-input style="width:200px" v-model="form.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传凭证" :rules="[
            { required: true, message: '请上传凭证'},
          ]">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            multiple>
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">确认入库</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";
import Button from "../sys/button.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      searchForm: {
        totalCount: 0,
        current: 1,
        size: 10,
        keyword: "",
        state: "", 
      },
      form:{
        price:'',
      },
      input:'',
      value:'',
      options:{
        value:1,
        label:'街电'
      },
      radio: "",
      logisticsDialogVisible: false, //查看物流
      warehouseWarrantDialogVisible: true, //入库单
      drqDialogVisible: true, //待入库
      yrkDialogVisible: true, //已入库
      qrrkDialogVisible: true, //确认入库
      tableData: [],
      tableSelection: [],
      dialogImageUrl: "",
      dialogVisible: false,
      reverse: true,
      img1:require("../../img/待入库.png"),
      img2:require("../../img/待入库总数.png"),
      img3:require("../../img/今日新增入库单.png"),
      img4:require("../../img/已入库单数.png"),
      img5:require("../../img/已入库总数.png"),
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
          color: '#0bbd87'
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
    };
  },
  created() {
    this.query();
  },
  methods: {
    beforeAvatarUpload(file) {
      console.log(file)
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSizeChange(v) {
      this.searchForm.size = v;
      this.query();
    },
    handleCurrentChange(v) {
      this.searchForm.current = v;
      this.query();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.search();
    },
    search() {
      if (this.searchForm.name) {
        this.tableData = this.tableData.filter(
          (e) => e.btnName.indexOf(this.searchForm.name) >= 0
        );
      } else {
        this.query();
      }
    },
    queryCount() {
      //获取接口
      this.$api.inorder
        .getHouseInOrderCount({})
        .then((d) => {
          if (d.code == 200) {
            console.log(d.data)
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    query() {
      //获取接口
      this.$api.inorder
        .getHouseInOrderList(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //确认入库
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        let data={
          content:{},
          img:'',
          orderId:'',
          price:'',
        }
        if (valid) {
          this.$api.inorder
            .houseInStock(data)
            .then((d) => {
              if (d.code == 200) {
             
              } else {
                this.$message.error(d.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang='less'>
.grid-content {
  display: flex;
  padding: 15px 10px;
  background-color: aliceblue;
  .img {
    width: 75px;
    height: 75px;
  }
  .total {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 1;
    padding-left: 10px;
  }
  p {
    margin: 0;
    display: flex;
    align-items: baseline;
  }
}
.font36 {
  font-size: 36px;
  margin-right: 5px;
}
.row{
  padding: 10px;
  min-height: 35px;
  box-sizing: border-box;
  border: 1px solid var(--table-border);
}
.flex1{
  flex:1;
  text-align: center;
}
.border-8e{
  border: 1px solid var(--table-border);
}
</style>